import { toast } from 'react-toastify'

export const notifySuccess = (message) => toast.success(message)

export const notifyError = (errorMessageEnglish, errorMessagePolish, error) => {
  if (errorMessagePolish) toast.error(errorMessagePolish)
  if (error) console.error(errorMessageEnglish, error)
}
